export default "__VITE_ASSET__CRBs_6kz__"